export const ROOT_ROUTE_NAMES = {
  ACCOUNT_MAPPINGS: 'account-mappings',
  ADMIN_TOOLS: 'admin-tools',
  DASHBOARD: 'dashboard',
  ERROR_403: '403',
  ERROR_404: '404',
  JOIN_TODAY_PAYMENTS: 'join-today-payments',
  PAYMENT_PROGRAM_SELECT: 'payment-program-select',
  LEAFLINK_FEATURES: 'leaflink-features',
  LOGOUT: 'logout',
  PAYMENTS: 'payments',
  PAYMENTS_ACCOUNT_SETTINGS: 'payments-account-settings',
  PAYMENTS_SETTINGS_PREFERENCES: 'payments-settings-preferences',
  PAYMENTS_SIGN_UP: 'payments-sign-up',
  ROOT: 'root',
  SHARE_LEAFLINK: 'share-leaflink',
  SHAREABLE_LINKS: 'shareable-links',
  OAUTH2_CALLBACK: 'oauth2-callback',
};
